import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import MainCreateProduct from "./MainCreateProduct";
import CreateProductFooter from "./CreateProductFooter";
import { useEffect, useState } from "react";
import { AttributeInput, CreateProductInput } from "services/interface";
import _ from "lodash";
import { useCreateProduct } from "hooks/useProduct";
//import { useQueryClient } from "react-query";

const CreateProduct = () => {
  const navigate = useNavigate();
  const [attribute, setAttribute] = useState<AttributeInput[]>([]);
  const [variants, setVariants] = useState<VariantsInput>([]);
  const [prices, setPrices] = useState<PricesInput>([]);
  const [content, setContent] = useState<string>("");
  const [is_guid, setIsGuid] = useState<boolean>(true);
  const [is_inventory, setIsInventory] = useState<boolean>(false);

  const [checkIsActive, setCheckIsActive] = useState<boolean>(false);

  const { mutate: CreateProduct, isPending } = useCreateProduct();

  const [form] = Form.useForm();

 // const queryClient = useQueryClient();

  const onFinish = (values: any) => {
    // console.log("Success:", values);
    if (checkIsActive) {
      //_.isEmpty(attribute) ||

      if(values.description === "<p></p>\n"){
        form.setFieldsValue({
          description: "",
        });
        form.validateFields({
         
          });
        message.error("กรุณากรอกคำอธิบายสินค้าให้ถูกต้อง ");
        return;
      }

      if (_.isEmpty(variants) || _.isEmpty(prices)  ) {
        message.error("กรุณากรอกตัวเลือกสินค้าให้ถูกต้อง ");
        return;
      }

    }

    let new_main_images: any = [];

    if (values.main_images) {
      new_main_images = values.main_images.map((item: any) => {
        return item.id;
      });
    }

    // const new_main_images = values.main_images.map((item: any) => {
    //   return item.id;
    // });

    let new_description_images: any = [];

    if (values.description_images) {
      new_description_images = values.description_images.map((item: any) => {
        return item.id;
      });
    }

    const crateProductInput: CreateProductInput = {
      name: values.name,
      recomended_retail: values.recomended_retail,
      description: content,
      category_id: values.category_id,
      main_images: new_main_images,
      prices: prices,
      variants: variants,
      properties: attribute,
      description_images: new_description_images,
      is_active: values.is_active,
      retail_type: values.retail_type,
      video_url: values.video_url,
      is_guid: is_guid,
    };

    console.log("crateProductInput", crateProductInput);

    CreateProduct(crateProductInput, {
      onSuccess: (data) => {
        // queryClient.invalidateQueries("getProductList");
        // queryClient.invalidateQueries("getProductListInActive");
        // queryClient.invalidateQueries("getProductListApprove");
        navigate("/manage-product");
      },
      onError: (error) => {
        console.log("error", error);
        message.error("เกิดข้อผิดพลาด");
      },
    });
  };

  useEffect(() => {
    form.setFieldsValue({
      description: content,
    });
    form.setFieldsValue({
      is_guid: true,
    });
  }, [content, form]);

  return (
    <Form form={form} onFinish={onFinish}>
      <Row className="rowgap-vbox" gutter={[24, 0]}>
        <Col span={24}>
          <Card bordered={false} className="criclebox h-full tabs-mobile">
            <HeaderTabs>
              <IconWrapper
                onClick={() => {
                  navigate("/manage-product");
                }}
              >
                <SpanIcon>{goBack}</SpanIcon>
              </IconWrapper>
              <Typography.Title level={5}>เพิ่มสินค้า</Typography.Title>
              <RightIconWrapper></RightIconWrapper>
            </HeaderTabs>
            <WrapperAll>
              <MainCreateProduct
                form={form}
                onFinish={onFinish}
                attribute={attribute}
                setAttribute={setAttribute}
                variants={variants}
                setVariants={setVariants}
                prices={prices}
                setPrices={setPrices}
                setCheckIsActive={setCheckIsActive}
                checkIsActive={checkIsActive}
                setContent={setContent}
                content={content}
                is_guid={is_guid}
                setIsGuid={setIsGuid}
                is_inventory={is_inventory}
              />
            </WrapperAll>
          </Card>
        </Col>
      </Row>
      <CreateProductFooter loading={isPending} />
    </Form>
  );
};

export default CreateProduct;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
